<template>
  <div>
    <label class="label">{{$t("bank_name").tTitle()}}</label>
    <div class="control">
      <span class="select is-fullwidth">
        <select
          name="bankOption"
          id=""
          @change="updateValue"
          v-model="currentBank"
        >
          <option value>{{$t('select').tTitle()}}</option>
          <option
            v-for="(bank, i) in banks"
            :key="'bank'+i"
          >{{bank}}</option>
        </select>
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['banks'],
  model: {
    prop: 'currentBank',
    event: 'change',
  },
  data() {
    return {
      currentBank: '',
    }
  },
  mounted() {},
  methods: {
    updateValue() {
      this.$emit('change', this.currentBank)
    },
  },
  computed: {
    ...mapGetters({
      // User: 'user/all',
      Language: 'language/code',
    }),
  },
}
</script>



// WEBPACK FOOTER //
// Banklist.vue?17fe4aec